import React from "react";
import URLs from "constants/urls";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import InsuranceReportsheet from "./insuranceDashbrd";
const InsuranceDashboard = () => {
  return (
    <DashboardLayout>
      <InsuranceReportsheet />
    </DashboardLayout>
  );
};

export default InsuranceDashboard;
